import script from "./StatsImpacts2.vue?vue&type=script&lang=js"
export * from "./StatsImpacts2.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__